import { Directive, Input, HostListener } from '@angular/core';
import { ElementRef } from '@angular/core';
import {
  AnimationPlayer,
  AnimationBuilder,
  AnimationMetadata,
  animate,
  style,
} from '@angular/animations';

@Directive({
  selector: '[animateSelect]',
})
export class AnimateSelectDirective {
  player: AnimationPlayer;
  errorState = false;
  focused: boolean = false;
  labelRef: ElementRef;
  iconExist: boolean;
  selected: boolean;

  @Input()
  set error(error: boolean) {
    if (error) {
      this.performAnimation('error');
      this.errorState = true;
    } else {
      this.errorState = false;
      let state = this.focused ? 'focus' : 'normal';
      this.performAnimation(state);
      if (this.labelRef) {
        this.triggerAnimation(this.labelPositionState, 'labelPositionAnimation', this.labelRef);
      }

    }
  }

  @Input()
  set label(labelRef: any) {
    this.labelRef = labelRef;
  };

  @Input()
  set leadingIcon(icon: any) {
    this.iconExist = !!icon;
  };

  @Input()
  set selectValue(selectValue) {
    // if (!this.focused) {
    // console.log(51, isSelected);
    this.selected = selectValue;
    this.triggerAnimation(this.labelPositionState, 'labelPositionAnimation', this.labelRef);
    // }
  }

  private animationData = {
    labelColorAnimation: {
      normal: [animate('200ms ease-in', style({ color: '#777777' }))],
      hover: [animate('200ms ease-in', style({  color: '#777777' }))],
      focus: [animate('200ms ease-in', style({  color: '#26C6DA' }))],
      error: [animate('200ms ease-in', style({   color: '#FF4F58' }))],
    },
    inputBorderColorAnimation: {
      normal: [style({ borderColor: '#DDDDDD' }), animate('200ms ease-in', style({ borderColor: '#DDDDDD' }))],
      hover: [style({ borderColor: '#DDDDDD' }), animate('200ms ease-in', style({ borderColor: '#777777' }))],
      focus: [style({ borderColor: '#DDDDDD' }), animate('200ms ease-in', style({ borderColor: '#26C6DA' }))],
      error: [style({ borderColor: '#DDDDDD' }), animate('200ms ease-in', style({ borderColor: '#FF4F58' }))],
    },
    labelPositionAnimation: {
      'normalLi': [animate('200ms ease-in', style({ transform: 'translateY(0px)', left: '39px'}))],
      'normal': [animate('200ms ease-in', style({ transform: 'translateY(0px)', left: '17px'}))],
      'top': [animate('200ms ease-in', style({
        transform: 'translateY(-16px)',
        left: '17px',
      }))]
    }
  };


  @HostListener('mouseenter') onMouseEnter() {
    if (this.focused) {
      return;
    }
    this.performAnimation('hover');
  }
  @HostListener('mouseleave') onMouseLeave() {
    if (this.focused) {
      return;
    }
    this.performAnimation('normal');
  }
  @HostListener('focus') onFocus() {

    this.performAnimation('focus');
    this.triggerAnimation('top', 'labelPositionAnimation', this.labelRef);
    this.focused = true;
  }
  @HostListener('blur') onBlur() {
    this.focused = false;
    this.performAnimation('normal');
    this.triggerAnimation(this.labelPositionState, 'labelPositionAnimation', this.labelRef);
  }

  constructor(private builder: AnimationBuilder, private el: ElementRef) {
    if (el) {
      el.nativeElement.style.border = '1px solid #DDDDDD';
    }
  }

  private performAnimation(state) {
    if (this.errorState) {
      return;
    }
    if (this.labelRef) {
      this.triggerAnimation(state, 'labelColorAnimation', this.labelRef);
    }
    if (this.el) {
      this.triggerAnimation(state, 'inputBorderColorAnimation', this.el.nativeElement);
    }
  }

  private triggerAnimation(state: string, animationType: string, element: ElementRef) {
    if (this.player) {
      this.player.destroy();
    }
    const metadata = this.animationData[animationType][state];

    const factory = this.builder.build(metadata);
    const player = factory.create(element);

    player.play();
  }

  get labelPositionState() {
    let state;
    if (this.el && this.selected) {
      state = 'top';
    } else if (this.iconExist) {
      state = 'normalLi';
    } else {
      state = 'normal';
    }
    return state;
  }

}



// WEBPACK FOOTER //
// ./src/app/directives/animate-select.directive.ts